import React, { useEffect, useState, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/title.scss';
import Color from '@tool/color';
import ShapeIcon from '@static/icon/shape01.png';

interface IProps {
  title: string,
  subtitle?: string,
  year?: any,
  color?: string
  bgcolor?: string
}
interface IState { }

const MainTitle = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { title, subtitle, year, color, bgcolor } = props;

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section className="title-pdf-top">
      <p className='top'><span /><i />{title}<i /><span /></p>
      <p className='bot'>
        <span style={{ color: color, backgroundColor: bgcolor }}>{subtitle}</span>
        {year && <i>{year}</i>}
      </p>
    </section>
  );
};

export default observer(MainTitle);
